/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import HorizontalScroll from '../shared/HorizontalScroll';

function CourseTags({
  tagsList, queryPareamsTag, changeCourseTag, homePadding, pageType,
}) {
  const [selectedTag, setSelectedTag] = useState('');
  const router = useRouter();
  const updateQueryParam = (key, value) => {
    const url = new URL(window.location.href);
    url.searchParams.set(key, value);
    // Now push it to history without page reload
    if (pageType !== 'mocktest') {
      router.replace(url.toString(), undefined, { shallow: true });
    } else {
      window.history.replaceState(null, '', url);
    }
    // window.history.pushState({}, '', url); // replace this with native router method for resolve browser back button issue
  };

  const handleTabClick = (tagId) => {
    updateQueryParam('tag', tagId);
    setSelectedTag(tagId);
    if (tagId === 'all') {
      changeCourseTag();
    } else {
      changeCourseTag(tagId);
    }
  };
  useEffect(() => {
    setSelectedTag(queryPareamsTag || 'all');
  }, [queryPareamsTag]);
  return (

    <div className={`flex justify-center sm:justify-center md:justify-center xl:justify-start lg:justify-start ${homePadding || 'lg:pb-5 pb-4'}`}>
      <HorizontalScroll className="gap-2">
        <ul className="flex gap-2">
          {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
          <li
            onClick={() => handleTabClick('all')}
            className={`${selectedTag === 'all' ? 'text-white bg-tabBlue' : 'bg-white border-[#B9BFC1]'} tab-btn lg:py-2 py-[6px] border-2 uppercase lg:px-6 px-4 text-sm font-normal text-gray-700 rounded-full cursor-pointer whitespace-nowrap`}
          >
            All
          </li>
          {tagsList?.map((res) => (
            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
            <li
              onClick={() => handleTabClick(res?.id)}
              className={`${res.id === selectedTag ? 'text-white bg-tabBlue' : 'bg-white border-[#B9BFC1]'} tab-btn lg:py-2 py-[6px] border-2 uppercase lg:px-6 px-4 text-sm font-normal text-gray-700 rounded-full cursor-pointer whitespace-nowrap`}
              key={res.id}
            >
              {res.name}
            </li>
          ))}
        </ul>
      </HorizontalScroll>
    </div>
  );
}

export default CourseTags;
